import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { DataListParams, DataListProp, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import { getMatchingSelectData, runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { equipClipboard } from "../../inputCols/clipboard";
import { enLocale } from "@/i18n/routing";
export const UserItem = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;

  const utcOffset = dayjs().utcOffset() * 60000;
  switch (params?.page.page ?? "") {
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_cafe","system_TABLE_NAME":"user_equip_list","system_table_pk":["user_seq","user_equip_seq"],"system_table_page":"UserEquip","system_table_path":"user/item/equip","system_table_page_name":"UserEquip","system_table_auth":["SADMIN","ADMIN","USER","ROASTER"],"system_select_auth":["cafe"],"system_user_auth":"SMNG","system_user_auth_field":["equip_auth"],"system_table_mapper":"cafe","system_table_detail_result":"detail_result","system_table_search_column":["equip_type"],"system_table_search_select":["equip_name_locale","equip_name"],"system_table_order_column":["equip_type","equip_name_locale"],"system_table_default_name_column":"equip_name_locale","system_table_en_name_column":"equip_name"},
    //--info--"change":{"equip_type":{"COLUMN_CODE_SELECT":"EQUIP"},"equip_type_list":{"COLUMN_CODE_SELECT":"EQUIP"}}
    //--info--}

    case "UserEquip":
      return {
        ...result,
        dataFetch: { fetchUrl: "/api/user/item/equip/detail/", saveFetch: { fetchUrl: "/api/user/item/equip/edit" } },
        listFetch: { fetchUrl: "/api/user/item/equip/list" },
        dataResultName: "detail_result",
        dataName: "UserEquipData",
        clipboard: equipClipboard(formFunction?.current),
        dataCols: {
          //user_equip_seq: { ...dc.seq },
          equip_name_locale: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
          equip_name: { ...dc.inputFull, required: true, minLength: 3, maxLength: 300, showCount: true },
          equip_nick_locale: { ...dc.inputFull, maxLength: 300, showCount: true },
          equip_nick: { ...dc.inputFull, maxLength: 300, showCount: true },
          equip_type: {
            ...dc.select,
            inputClassName: dc.inputCountryClassName,
            required: true,
            minLength: 3,
            maxLength: 45,
            codeGroup: "EQUIP",
            selectChangeLoad: ["equip_manufacture_seq", "equip_seq"],
          },
          equip_manufacture_seq: {
            ...dc.selectSearch,
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/code/company",
            dataProp: {
              fixedParam: { company_type: "EQD" },
              requiredParam: ["company_type"],
              userAuth: false,
              load: (data, select_data) => {},
            },
            dataLabel: {
              value: "company_seq",
              label: [
                { field: "company_name_locale", subs: "company_nick_locale" },
                { field: "company_name", subs: "company_nick" },
              ],
            },
            selectFieldFilter: { company_type_list: "equip_type" },
            selectChangeLoad: ["equip_seq"],
          },
          equip_seq: {
            ...dc.selectSearch,
            label: "equip_ref_seq",
            inputClassName: dc.inputCountryClassName,
            dataUrl: "/api/code/product/equip",
            dataProp: {
              //fixedParam: { company_type: "EQD" },
              valueParam: { equip_type: "equip_type", equip_manufacture_seq: "equip_manufacture_seq" },
              requiredParam: ["equip_type", "equip_manufacture_seq"],
              userAuth: false,
              // load: (data, select_data) => {
              // },
            },
            onChange: (data) => {
              const result = getMatchingSelectData(form?.current, formFunction?.current, formMemo?.current, "equip_seq", [
                "equip_seq",
                "edit_at",
              ]);
              //Debug(result);
              form?.current?.setFieldsValue(result);
              setTimeout(() => {
                runFormFunction(formFunction?.current, ["equip_type", "equip_manufacture_seq"], "changeLoad");
              }, dc.setTimeoutShort);
              //greenbean_region_seq, greenbean_farm_seq
            },
            dataLabel: {
              value: "equip_seq",
              label: [
                { field: "equip_name_locale", subs: "equip_nick_locale" },
                { field: "equip_name", subs: "equip_nick" },
              ],
            },
          },
          // 만들어만 놓고 쓰지 않기. 추후 친구 추가 및 기타등으로 조회 할 수 있을일이 있으면 쓸것
          // equip_auth: {
          //   ...dc.cafeAuth,
          //   inputClassName: dc.inputCountryClassName,
          //   label: "select_auth",
          // },
          equip_zero_point: { ...dc.number2f },
          equip_option: { ...dc.textArea, maxLength: 10000 },
          equip_detail: { ...dc.textArea, maxLength: 10000 },
          equip_purchase_date: { ...dc.date },
          equip_use: { ...dc.useDefault, required: true },
          rgst_by: { ...dc.rgst },
          edit_by: { ...dc.edit },
        },

        listColLinkField: "user_equip_seq",
        listSearch: [
          { ...dc.select, inputType: "select", codeGroup: "EQUIP", field: "search0", label: "equip_type", placeholder: "equip_type" },
        ],
        listSearchSelect: [{ ...dc.input, field: "search_title_all", label: "equip_name_locale", placeholder: "equip_name_locale" }],
        listOrder: ["equip_type_orderasc", "equip_type_orderdesc", "equip_name_locale_orderasc", "equip_name_locale_orderdesc"],
        listCols: [
          //"user_seq",
          // "user_equip_seq",
          params?.locale === enLocale ? "equip_name" : "equip_name_locale",
          //"equip_nick",
          //"equip_nick_locale",
          { field: "equip_type", codeGroup: "EQUIP", selectProp: { mode: "multiple" } },
          //{ field: "equip_type_list", codeGroup: "EQUIP", inputDirect: "equip_type_list", selectProp: { mode: "multiple" } },
          //"equip_manufacture_seq",
          //"equip_detail",
          //"equip_option"
        ],
      };
    default:
      return undefined;
  }
};
